import React, { useLayoutEffect, useRef, useState } from "react";
import "./ContactUs.css"; 
import { gsap } from "gsap"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
// Import Footer
import Footer from "../../components/common/Footer/Footer";

function ContactUs() {
  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useLayoutEffect(() => {
    document.title = "Contact Us | Dandelion Run Community";
    
    gsap.fromTo(
      formRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);

  // --- STRONGER ANTI-SPAM PATTERN ---
  // Blocks http, https, www, domains, and image extensions
  const urlBlockPattern = "((?!http|https|www|\\.com|\\.net|\\.org|\\.io|\\.ca|\\.co|\\.uk|\\.jpg|\\.png|\\.gif|\\.jpeg).)*";

  const handleSubmit = (event) => {
    event.preventDefault(); 
    setIsSubmitting(true); 
    
    // Simulate backend request
    setTimeout(() => {
      const didSucceed = Math.random() > 0.5;
      if (didSucceed) {
        toast.success("Message sent! We'll be in touch.");
        setIsSubmitting(false); 
        event.target.reset(); 
      } else {
        toast.error("Something went wrong. Please try again.");
        setIsSubmitting(false); 
      }
    }, 2000);
  };
  
  return (
    <>
      <section className="contact-page-section">
        
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          theme="dark"
        />

        <div className="glass-form-container" ref={formRef}>
          
          <form 
            name="contact"
            method="POST" 
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="form-name" value="contact" />
            
            <h2 className="contact-title">Get In Touch</h2>
            
            {/* --- Honeypot Field (Bot Trap) --- */}
            <div className="honeypot-field">
              <label>Don’t fill this out if you're human:</label>
              <input name="bot-field" />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="first-name">First Name</label>
                <input type="text" id="first-name" name="first-name" required />
              </div>
              
              <div className="form-group">
                <label htmlFor="last-name">Last Name</label>
                <input type="text" id="last-name" name="last-name" required />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              {/* Email field is SAFE (no pattern restriction) */}
              <input type="email" id="email" name="email" required />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea 
                id="message" 
                name="message" 
                rows="6" 
                required
                placeholder="How can we help you?"
                // --- RESTRICTED: Blocks Links & Images ---
                pattern={urlBlockPattern}
                title="Links, URLs, and image files are not allowed in the message."
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="contact-submit-button"
              disabled={isSubmitting} 
            >
              {isSubmitting ? (
                <>
                  <div className="loader"></div> 
                  Sending...
                </>
              ) : (
                "Send Message" 
              )}
            </button>
            
          </form>
        </div>
        
      </section>

      {/* Footer included for Contact Page */}
      <Footer />
    </>
  );
}

export default ContactUs;